module.exports = __webpack_public_path__ + "img/password-login.ddaf8564.svg";